@if (backgroundImageUrl) {
  <div class="zwi-embed-cover-art zwi-ministry-embed-cover-art" [style.background-image]="backgroundImageUrl"></div>

}
